import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IonInput } from '@ionic/angular';

@Component({
  selector: 'input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss']
})
export class InputFieldComponent {

  @ViewChild(IonInput) input!: IonInput;

  @Input() value: string = '';
  @Output() valueChange: EventEmitter<string> = new EventEmitter();
  @Input() label: string = '';
  @Output() rawValueChange: EventEmitter<string> = new EventEmitter();

  @Input() readonly: boolean = false;
  @Input() allowToggleToEditMode: boolean = false;
  @Input() format: FormatterType = FormatterType.NONE;
  @Input() disabled: boolean = false;

  @Output() changed: EventEmitter<void> = new EventEmitter();

  @Input() isError: boolean = false;
  public isFocused: boolean = false;

  public get maxLength(): number | null {
    if (this.format === FormatterType.PHONE) {
      return 12;
    }
    if (!this.format && this.label.toLowerCase() === 'phone') {
      return 17;
    }
    return null;
  }

  public filterInput(event: CustomEvent) {
    this.setError(false);
    if (this.format === FormatterType.PHONE) {
      const filtered = (<string>event.detail.value).replace(/[^0-9+]+/g, '');
      this.input.value = filtered;
    }
    if (this.format === FormatterType.NUMBER) {
      const filtered = (<string>event.detail.value).replace(/\D/g, '');
      this.input.value = filtered;
    }

    if (!this.format && this.label.toLowerCase() === 'phone') {
      this.applyPhoneMask(event.detail.value);
    }
  }

  public onKeyPress(event: KeyboardEvent) {
    if (!this.format && this.label.toLowerCase() === 'phone') {
      const currentValue = this.value;
      const digits = currentValue.replace(/\D/g, '');

      const allowed = /[0-9+()]/;
      if (!allowed.test(event.key)) {
        event.preventDefault();
        return;
      }

      if (digits.length === 0 && event.key !== '1') {
        event.preventDefault();
        return;
      }
      
      if (digits.length > 0 && digits.charAt(0) !== '1') {
        event.preventDefault();
        return;
      }
    }
  }

  private applyPhoneMask(value: string) {
    const digits = value.replace(/\D/g, '');
  
    // number of digits is limited by 11, and apply mask only if starts with 1
    const limitedDigits = digits.substring(0, 11);
  
   
    if (!limitedDigits.startsWith('1')) {
      this.value = limitedDigits;
      this.valueChange.emit(limitedDigits);
      this.rawValueChange.emit(limitedDigits);
      return;
    }
  
    // formatting mask: +1 (___) ___-____
    let formatted = '+1';
    const len = limitedDigits.length;
  
    if (len > 1) {
      formatted += ' (' + limitedDigits.substring(1, Math.min(4, len));
    }
  
    if (len >= 4) {
      formatted += ') ' + limitedDigits.substring(4, Math.min(7, len));
    }
  
    if (len >= 7) {
      formatted += '-' + limitedDigits.substring(7, Math.min(11, len));
    }
  
    this.value = formatted;
    this.valueChange.emit(formatted);
    this.rawValueChange.emit('+1' + limitedDigits.substring(1));
  }
  

  public onChange(event: CustomEvent) {
    // const value = event.detail.value?.trim();
    // this.checkValue(value);
  }

  public setEditMode() {
    this.readonly = false;
    setTimeout(() => {
      this.input?.setFocus();
    }, 10);
  }

  public save() {
    if (this.isError) {
      return;
    }
    this.isFocused = false;
    this.readonly = true;
    const trimmedValue = (<string>this.input.value)?.trim()?.replace(/[ ]{2,}/g, ' ');
    this.input.value = trimmedValue;
    this.checkValue(trimmedValue);
  }

  public onFocus() {
    if (!this.readonly) {
      this.isFocused = true;
    }
  }

  public onBlur() {
    this.isFocused = false;
    const trimmedValue = (<string>this.input.value)?.trim()?.replace(/[ ]{2,}/g, ' ');
    this.input.value = trimmedValue;
    if (!this.isError && !this.allowToggleToEditMode) {
      this.checkValue(trimmedValue);
    }
  }

  private setError(isError: boolean) {
    this.isError = isError
  }

  private emitValue(value: string) {
    this.valueChange.emit(value);
    this.changed.emit();
  }

  private checkValue(value: string) {
    this.setError(false);

    if (this.format === FormatterType.PHONE) {
      if (this.checkPhone(value)) {
        this.emitValue(value);
      } else {
        this.setError(true);
      }
    } else if (this.format === FormatterType.EMAIL) {
      if (this.checkEmail(value)) {
        this.emitValue(value);
      } else {
        this.setError(true);
      }
    } else if (this.format === FormatterType.NAME) {
      if (this.checkUserName(value)) {
        this.emitValue(value);
      } else {
        this.setError(true);
      }
    } else {
      this.emitValue(value);
    }
  }

  private checkPhone(tel?: string): boolean {
    if(!tel||tel.trim().length == 0) return true;
    let firstPlus = tel.charAt(0) == '+';
    let isnum = /^\d+$/.test(tel.slice(1));
    let telLenght = tel.length == 12;
    return firstPlus && isnum && telLenght;
  }

  private checkEmail(email: string): boolean {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ) ? true : false;
  }

  private checkUserName(name: string): boolean {
    return name.match(/^([A-Z]{1}[a-z]* [A-Z]{1}[a-z]*)$/g) ? true : false;
  }

  public getRawPhoneValue(): string {
    if (this.format === FormatterType.PHONE || (!this.format && this.label.toLowerCase() === 'phone')) {
      const digits = this.value.replace(/\D/g, '');
      if (digits.length === 11 && digits.startsWith('1')) {
        return '+1' + digits.substring(1);
      }
      return digits;
    }
    return this.value;
  }
}

export enum FormatterType {
  NONE = '',
  NAME = 'name',
  EMAIL = 'email',
  PHONE = 'tel',
  NUMBER = 'number'
}
